module.exports = __webpack_public_path__ + "2191bd1c93d5ff06f4af283898c6391d.svg";